export default "__VITE_ASSET__BQBifv8C__"